<template>
  <div class="riskManagement">
		<div>
			<el-form :model="searchForm" ref="searchForm" label-width="140px">
				<el-row>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Risk Type:" prop="riskType">
							<el-select clearable v-model="searchForm.riskType" placeholder="Please select">
								<el-option
									v-for="item in projectRiskType"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Risk Level:" prop="riskLevel">
							<el-select clearable v-model="searchForm.riskLevel" placeholder="Please select">
								<el-option
									v-for="item in riskLevel"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Risk Description:" prop="riskDesc">
							<el-input clearable v-model="searchForm.riskDesc" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Risk Status:" prop="status">
							<el-select clearable v-model="searchForm.status" placeholder="Please select">
								<el-option
									v-for="item in riskStatus"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Owner:" prop="personResponsible">
							<el-select
								v-model="searchForm.personResponsible"
								clearable
								filterable
								remote
								placeholder="Please input"
								:remote-method="value => filterUser('personSearchList', value)"
							>
								<el-option v-for="(item, index) in personSearchList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="18" :lg="8" :md="12" style="padding: 10px 0 0 20px; text-align: right;">
						<el-button type="primary" size="small" @click="handleSearch()">Search</el-button>
						<el-button size="small" @click="handleReset()">Reset</el-button>
						<!-- <el-button size="small" :loading="exportLoading" @click="handleExport()">Export</el-button> -->
						<!-- <el-button type="primary" size="small" :loading="saveLoading" @click="saveRisk">Save</el-button> -->
					</el-col>
				</el-row>
			</el-form>
			<el-divider style="margin: 14px 0 0 0"></el-divider>
			<el-form :model="riskForm" ref="riskForm" label-width="0">
				<el-row>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Project Overall Health:" prop="allRiskLevel" :rules="{ required: true, message: 'Please select' }" label-width="180px" class="allrisk">
							<el-select clearable v-model="riskForm.allRiskLevel" placeholder="Please select" 
							 :class="riskForm.allRiskLevel === 1 ? 'redbg' :riskForm.allRiskLevel === 2 ? 'yellowbg' : riskForm.allRiskLevel === 3 ? 'greenbg' :''">
								<el-option
									v-for="item in riskLevel"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="18" :lg="16" :md="12" style="padding: 15px 0 0 20px; text-align: right;">
						<el-button type="primary" size="small" :loading="saveLoading" @click="saveRisk" v-if="allData && allData.projectStatus !== 5">Save</el-button>
						<el-button size="small" :loading="exportLoading" @click="handleExport()">Export</el-button>
					</el-col>
				</el-row>
				<el-table :data="riskForm.tableData" border v-loading="tableLoading" class="task-table" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
					<el-table-column label=""  width="38">
						<template v-slot="scope" v-if="allData && allData.projectStatus !== 5">
							<i class="el-icon-circle-plus-outline" style="font-size: 20px; margin-top: 2px;" @click="addRow(scope.$index)"></i>
							<i class="el-icon-remove-outline" style="font-size: 20px;; margin-top: 2px;" @click="deleteRow(scope.row, scope.$index)"></i>
						</template>
					</el-table-column>
					<el-table-column label="No." type="index" sortable width="50" align="center"></el-table-column>
          <el-table-column prop="riskType" width="150">
						<template slot="header">
							<span class="hasStar">Risk Type<span>*</span></span>
						</template>
						<template v-slot="scope">
							<el-form-item :prop="'tableData.' + scope.$index + '.riskType'" :rules="{ required: true, message: 'Please select' }">
								<el-select clearable v-model="scope.row.riskType" placeholder="">
									<el-option
										v-for="item in projectRiskType"
										:key="item.labelKey"
										:label="item.labelValue"
										:value="item.labelKey"
									>
									</el-option>
								</el-select>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column prop="riskLevel" width="200">
						<template slot="header">
							<span class="hasStar">
								Risk Level<span>*</span>
								<el-tooltip class="item" effect="dark" placement="top-start">
									<div slot="content">
										Please refer to: Risk Level Definition. 
									</div>
									<i class="el-icon-question icon-label" />
								</el-tooltip>
							</span>
						</template>
						<template v-slot="scope">
							<el-form-item :prop="'tableData.' + scope.$index + '.riskLevel'" :rules="{ required: true, message: 'Please select' }">
								<el-select clearable v-model="scope.row.riskLevel" placeholder=""
								:class="scope.row.riskLevel === 1 ? 'redbg' :scope.row.riskLevel === 2 ? 'yellowbg' : scope.row.riskLevel === 3 ? 'greenbg' :''">
									<el-option
										v-for="item in riskLevel"
										:key="item.labelKey"
										:label="item.labelValue"
										:value="item.labelKey"
									>
									</el-option>
								</el-select>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="Risk Status" width="120">
						<template slot="header">
							<span class="hasStar">Risk Status<span>*</span></span>
						</template>
						<template v-slot="scope">
							<el-form-item :prop="'tableData.' + scope.$index + '.status'" :rules="{ required: true, message: 'Please select' }">
								<el-select clearable v-model="scope.row.status" placeholder="">
									<el-option
										v-for="item in riskStatus"
										:key="item.labelKey"
										:label="item.labelValue"
										:value="item.labelKey"
									>
									</el-option>
								</el-select>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column prop="riskDesc" width="350">
						<template slot="header">
							<span class="hasStar">Risk Description<span>*</span></span>
						</template>
						<template v-slot="scope">
							<el-form-item :prop="'tableData.' + scope.$index + '.riskDesc'" :rules="{ required: true, message: 'Please input' }">
								<el-input type="textarea" v-model="scope.row.riskDesc" clearable :title="scope.row.riskDesc" maxlength="500"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column prop="responseMeasures" width="350">
						<template slot="header">
							<span class="hasStar">Response Measures<span>*</span></span>
						</template>
						<template v-slot="scope">
							<el-form-item :prop="'tableData.' + scope.$index + '.responseMeasures'" :rules="{ required: true, message: 'Please input' }">
								<el-input type="textarea" v-model="scope.row.responseMeasures" clearable :title="scope.row.responseMeasures" maxlength="500"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column prop="currentProgress" width="350">
						<template slot="header">
							<span class="hasStar">Current Progress<span>*</span></span>
						</template>
						<template v-slot="scope">
							<el-form-item :prop="'tableData.' + scope.$index + '.currentProgress'" :rules="{ required: true, message: 'Please input' }">
								<el-input type="textarea" v-model="scope.row.currentProgress" clearable :title="scope.row.currentProgress" maxlength="500"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column prop="personResponsible" width="180">
						<template slot="header">
							<span class="hasStar">Owner<span>*</span></span>
						</template>
						<template v-slot="scope">
							<el-form-item :prop="'tableData.' + scope.$index + '.personResponsible'" :rules="{ required: true, message: 'Please input' }">
								<el-select
									v-model="scope.row.personResponsible"
									clearable
									filterable
									remote
									placeholder=""
									:title="scope.row.personResponsible"
									:remote-method="value => filterUser('personEditList', value)"
								>
									<el-option v-for="(item) in personEditList" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option>
								</el-select>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column prop="plannedClosingTime" width="180">
						<template slot="header">
							<span class="hasStar">Planned Closing Date<span>*</span></span>
						</template>
						<template v-slot="scope">
							<el-form-item :prop="'tableData.' + scope.$index + '.plannedClosingTime'" :rules="{ required: true, message: 'Please select' }">
								<el-date-picker
									v-model="scope.row.plannedClosingTime"
									type="date"
									value-format="yyyy-MM-dd" 
									placeholder=""
								>
								</el-date-picker>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column prop="riskClosureDate" width="180" label="Risk Closure Date">
						<template v-slot="scope">
							<el-form-item :prop="'tableData.' + scope.$index + '.riskClosureDate'">
								<el-date-picker
									v-model="scope.row.riskClosureDate"
									type="date"
									value-format="yyyy-MM-dd" 
									placeholder=""
									disabled
								>
								</el-date-picker>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column prop="expiringDesc" width="100">
						<template slot="header">
							<span>Expiring</span>
						</template>
						<template v-slot="scope">
							<el-form-item :prop="'tableData.' + scope.$index + '.expiringDesc'">
								<el-input v-model="scope.row.expiringDesc" placeholder="" disabled />
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column prop="overdueDesc" width="100">
						<template slot="header">
							<span>Overdue</span>
						</template>
						<template v-slot="scope">
							<el-form-item :prop="'tableData.' + scope.$index + '.overdueDesc'">
								<el-input v-model="scope.row.overdueDesc" placeholder="" disabled />
							</el-form-item>
						</template>
					</el-table-column>
				</el-table>
			</el-form>
		</div>
  </div>
</template>
<script>
	import moment from 'moment';
  export default {
    name: 'riskManagement',
		props: {
			id: {
				type: Number,
				default: null,
			},
			allData: {
				type: Object,
				default: {},
			}
		},
		watch: {
		},
    created () {
			this.getSelectInfo()
			this.handleSearch()
    },
    data () {
      return {
				moment,
				projectRiskType: [],
				riskLevel: [],
				riskStatus: [],
				personSearchList: [],
				personEditList: [],
        searchForm: {},
				tableLoading: false,
				currentPage: 1,
				pageSize: 10,
				totalCount: 1,
				exportLoading: false,
				riskForm: {
					tableData: [{}],
				},
				saveLoading: false,
				initUser: [],
      }
    },
    methods: {
			getSelectInfo() {
				let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
				let configKeyList = [
					'projectRiskType',
					'riskLevel',
					'riskStatus',
				]
				let str = '';
				configKeyList.forEach(item => {
					str += `&configKeyList=${item}`;
				})
				url = url + str.substring(1)
				const _this = this
				this._post(url).then(
					res => {
						if (res.data && res.code === 200) {
							Object.keys(res.data).forEach(function(key) {
								_this[key] = res.data[key];
							});
						}
					}
				)
			},
			addRow(index) {
				this.riskForm['tableData'].splice(index + 1, 0, {});
			},
			deleteRow(row, index) {
				if(row.id) {
					this.$confirm("Are you sure to delete", "Warning", {
						confirmButtonText: 'Confirm',
						cancelButtonText: 'Cancel',
						type: 'warning'
					}).then(() => {
						let url = `${this.$store.state.islhurl}projectRisk/delete`
						let params = {
							id: row.id,
							islhToken: sessionStorage.getItem('islhtoken'),
						}
						this._post(url, params).then(
							res =>{
								if(res.code === 200) {
									this.riskForm['tableData'].splice(index, 1);
									if (this.riskForm['tableData'].length === 0) {
										this.riskForm['tableData'].push({});
									}
									this.$Message.success('Delete Successful' );
									this.handleSearch();
								} else {
									this.$message({
										type:'error',
										message: res
									});
								}
							}
						)
					}).catch(() => {
					});
				} else {
					this.riskForm['tableData'].splice(index, 1);
					if (this.riskForm['tableData'].length === 0) {
						this.riskForm['tableData'].push({});
					}
				}
			},
			filterUser(list, query) {
				if (query !== '') {
					// 清除之前的定时器
					if (this.timeout) {
						clearTimeout(this.timeout)
					}
					// 防抖处理，300ms后执行
					this.timeout = setTimeout(() => {
						this.fetchUserOptions(list, query)
					}, 200)
				} else {
					this[list] = [];
				}
			},
			fetchUserOptions(list, query) {
				let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
				this._get(url).then().then(res => {
					if(res.code === 200 && res.data) {
						this[list] = res.data;
					} else {
						this[list] = [];
					}
				}).catch(error => {
					this[list] = [];
					console.error('搜索失败:', error)
				})
			},
			handleSearch() {
				let url = `${this.$store.state.islhurl}projectRisk/getListByPage/9999/1`
				let params = {
					majorProjectId: this.id,
					islhToken: sessionStorage.getItem('islhtoken'),
					...this.searchForm,
				}
				this.tableLoading = true;
				this._post(url, params).then(
					res =>{
						this.tableLoading = false;
						if(res.code === 200) {
							let tableData = [];
							res.data.forEach(item=>{
							  tableData.push({
							    ...item,
									plannedClosingTime: item.plannedClosingTime ? moment(item.plannedClosingTime).format('YYYY-MM-DD') : '',
									riskClosureDate: item.riskClosureDate ? moment(item.riskClosureDate).format('YYYY-MM-DD') : '',
							  })
							})
							const allLeaders = res.data.flatMap(entry => entry.personResponsible);
							this.initUser = [...new Set(allLeaders)];
							if (this.initUser && this.initUser.length > 0) {
								let obj = {
									empCodeList: this.initUser
								}
								let url =`${this.$store.state.islhurl}user/batch-get`;
								this._post(url, obj).then(
									res => {  
										if(res.code === 200 && res.data) {
											this.personEditList = res.data
										}
									}
								)
							}
							this.riskForm.tableData = tableData.length > 0 ? tableData : [{}] ;
							this.$nextTick(() => {
								this.$refs.riskForm.clearValidate();
							});
						} else {
							this.$message({
								type:'error',
								message: res
							});
						}
					}
				).catch(() => {
					this.tableLoading = false;
				});
				let url2 = `${this.$store.state.islhurl}majorProject/getProjectRiskLevelById?majorProjectId=${this.id}`
				let params2 = {
					majorProjectId: this.id,
					islhToken: sessionStorage.getItem('islhtoken'),
				}
				this._post(url2, params2).then(
					res =>{
						if(res.code === 200) {
							this.riskForm = {
								...this.riskForm,
								allRiskLevel: res.data
							}
							this.$nextTick(() => {
								this.$refs.riskForm.clearValidate();
							});
						}
					}
				)
			},
			changePageSize(size) {
				this.pageSize = size;
				this.handleSearch();
			},
			changePage(current) {
				this.currentPage = current;
				this.handleSearch();
			},
			handleReset() {
				this.searchForm = {};
			},
			handleExport() {
				this.exportLoading = true;
				this.$axios({
					url: `${this.$store.state.islhurl}projectRisk/exportData`,
					method: 'post',
					data: {
						...this.searchForm,
						majorProjectId: this.id,
						islhToken : sessionStorage.getItem('islhtoken'),
					},
					responseType: "blob"
				}).then(response=>{
					this.exportLoading = false;
					const blob = new Blob([response.data])
					const aEle = document.createElement('a');     // 创建a标签
					const href = window.URL.createObjectURL(blob);       // 创建下载的链接
					aEle.href = href;
					aEle.download = 'Risk Management_'+ moment().format('YYYYMMDD') +'.xlsx';  // 下载后文件名
					document.body.appendChild(aEle);
					aEle.click();     // 点击下载 
					document.body.removeChild(aEle); // 下载完成移除元素
					window.URL.revokeObjectURL(href) // 释放掉blob对象
				})
			},
			saveRisk() {
				this.$refs.riskForm.validate((valid) => {
					if (valid) {
						let url = `${this.$store.state.islhurl}projectRisk/save`
						let riskList = [];
						this.riskForm.tableData.forEach(item => {
							riskList.push({
								...item,
								projectName: this.allData.projectName, 
								projectId: this.id,
								plannedClosingTime: item.plannedClosingTime ? moment(item.plannedClosingTime).format('YYYY-MM-DD HH:mm:ss') : '',
								riskClosureDate: item.riskClosureDate ? moment(item.riskClosureDate).format('YYYY-MM-DD HH:mm:ss') : '',
							})
						})
						let params = {
							riskList,
							projectRiskLevel: this.riskForm.allRiskLevel,
							islhToken: sessionStorage.getItem('islhtoken'),
						};
						this.saveLoading = true;
						this._post(url, params).then(
							res =>{
              	this.saveLoading = false;
								if(res.code === 200) {
									this.$Message.success('Save Successful!' );
									this.handleSearch();
								} else {
									this.$message({
										type:'error',
										message: res
									});
								}
							}
						).catch(err => {
            _this.saveLoading = false;
          })
					} else {
						this.$message.error('Please check the red error message on the page content~')
        }
				});
			},
		},
  }
</script>
<style lang="less" scoped>
.riskManagement {
	.hiddencard {
		height: 0;
		overflow: hidden;
	}
	.el-form {
		padding: 20px 0 0 0;
		.el-form-item {
			margin-bottom: 10px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		.allrisk {
			/deep/.el-input {
				max-width: 350px;
			}
			/deep/.el-form-item__err {
				top: 86%;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
		/deep/.el-select {
			width: 100%;
		}
		.redbg /deep/.el-input__inner {
			background: #FF0000;
		}
		.yellowbg /deep/.el-input__inner {
			background: #FFFF00;
		}
		.greenbg /deep/.el-input__inner {
			background: #92D050;
		}
	}
	.task-table {
		margin-top: 5px;
		/deep/.cell {
			padding: 10px 8px 0 8px!important;
		}
		/deep/.el-table__header-wrapper .cell {
			padding: 8px!important;
		}
		/deep/.el-form-item {
			margin-bottom: 10px;
		}
		/deep/.el-form-item__error {
			padding-top: 0;
			top: 90%;
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: initial;
			right: 5px;
		}
		/deep/.el-select {
			width: 100%;
		}
		/deep/.el-table__cell {
			padding: 0;
			.el-input__inner {
				padding: 0 8px;
			}
			.el-input-number {
				width: 100%;
				.el-input__inner {
					text-align: left;
				}
			}
			.el-date-editor .el-input__inner {
				padding-left: 30px;
			}
			.el-textarea {
				margin-bottom: 7px;
			}
			.hasStar span {
				color: #F56C6C;
				padding-left: 1px;
			}
			.el-input__icon {
				line-height: inherit;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/riskManagement/index.vue